<template>
  <div>
    <router-view></router-view>
    <Loading></Loading>
    <NoticeToast></NoticeToast>
  </div>
</template>

<script>
import Loading from "./packs/components/loading/Loading";
import NoticeToast from "./packs/components/notice/NoticeToast";
export default {
  components: {
    NoticeToast,
    Loading
  },
  data: function () {
    return {
    }
  }
}
</script>

<style scoped>
</style>
